import { AxiosError,AxiosPromise } from 'axios'
import useSWR from 'swr'

import { ConversationApi } from 'api'

interface SFDCEnrichedOpportunity {
  StageName: string
}

interface SFDCEnrichedAccountOwner {
  Name: string
}

interface SFDCEnrichedAccount {
  Id: string
  Name: string
  Owner: SFDCEnrichedAccountOwner
  Industry: string
}

export interface SFDCEnrichmentResponseData {
  isEmpty: boolean
  baseUrl?: string
  accounts: SFDCEnrichedAccount[]
  opportunities: SFDCEnrichedOpportunity[]
}

const getSalesforceAccountData = ({
  accountDomain
}: {
  accountDomain: string
}): AxiosPromise<any> => {
  return ConversationApi.get(`/salesforce/enrichment?domain=${accountDomain}`)
}

export const useSalesforceAccountData = ({
  accountDomain
}: {
  accountDomain?: string
}): { data?: SFDCEnrichmentResponseData; error?: AxiosError } => {
  const { data, error } = useSWR<SFDCEnrichmentResponseData, AxiosError>(
    `salesforceAccountData-${accountDomain}`,
    async () => {
      if (!accountDomain) {
        return null
      }

      const { data } = await getSalesforceAccountData({ accountDomain })
      return data
    },
    {
      refreshInterval: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  )

  return { data, error }
}
